import { type ForwardRefRenderFunction, forwardRef } from 'react'

import { Checkbox as MUICheckbox, type CheckboxProps as MuiProps } from '@mui/material'

import { FormControlLabelStyled } from './styles'
import { ReactComponent as IconChecked } from './svg/Checked.svg'
import { ReactComponent as IconCheckedSmall } from './svg/CheckedSmall.svg'
import { ReactComponent as IconDefault } from './svg/Default.svg'
import { ReactComponent as IconDefaultSmall } from './svg/DefaultSmall.svg'
import { ReactComponent as IconIndeterminateSmall } from './svg/IndeterminateSmall.svg'
import { ReactComponent as IconIndeterminate } from './svg/Multiple.svg'

export interface CheckboxProps {
  label?: React.ReactNode
  indeterminate?: boolean
  checked?: boolean
  onChange?: MuiProps['onChange']
  id?: string
  disabled?: boolean
  size?: 'default' | 'small'
  bold?: boolean
}

const CheckboxComponent: ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> = (
  {
    checked,
    indeterminate,
    onChange,
    label = '',
    id,
    disabled = false,
    size = 'default',
    bold = false,
  },
  ref,
) => {
  const sizeIcons = {
    default: {
      checked: <IconChecked data-testid="checked-icon-checkbox" />,
      default: <IconDefault />,
      indeterminate: <IconIndeterminate />,
    },
    small: {
      checked: <IconCheckedSmall data-testid="checked-icon-checkbox" />,
      default: <IconDefaultSmall />,
      indeterminate: <IconIndeterminateSmall />,
    },
  }

  return (
    <FormControlLabelStyled
      bold={bold}
      control={
        <MUICheckbox
          checked={checked}
          checkedIcon={sizeIcons[size].checked}
          data-testid="checkbox"
          icon={sizeIcons[size].default}
          id={id}
          indeterminate={indeterminate}
          indeterminateIcon={sizeIcons[size].indeterminate}
          inputRef={ref}
          onChange={onChange}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
        />
      }
      disabled={disabled}
      label={label}
      size={size}
    />
  )
}

export const Checkbox = forwardRef(CheckboxComponent)
